<script>
  import { announce } from "./Logging.svelte";
  import { onMount, onDestroy } from "svelte";
  import { loadBackground } from "../backgroundStore.js";
  // Shown while no call is active. If a screen background was chosen in Settings it
  // is read from this device's browser storage (never from a server); otherwise the
  // screen stays black.
  export let prefs = {};
  let backgroundUrl = null;
  $: backgroundStyle = backgroundUrl
    ? `background-image: url("${backgroundUrl.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}");`
    : "";
  onMount(async () => {
    announce("InactiveWindow Mounted");
    const blob = await loadBackground();
    if (blob) backgroundUrl = URL.createObjectURL(blob);
  });
  onDestroy(() => {
    if (backgroundUrl) URL.revokeObjectURL(backgroundUrl);
  });
</script>

<style>
  .inactive {
    width: 100vw;
    height: 100vh;
    background-color: #000;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>

<section class="hero is-black is-fullheight inactive" style={backgroundStyle} aria-label="Waiting for a call" />
